<template>
  <v-container fluid ref="page" id="roadmap-page">
    <img id="orb-1" :src="require(`../assets/orb-3.svg`)" alt="Orb 1" />
    <img
      id="roadmap-cat"
      :src="require(`../assets/roadmap-cat.png`)"
      alt="Orb 1"
    />

    <img
      class="mt-7 laptop"
      id="roadmap"
      :src="require(`../assets/roadmap.png`)"
      alt="Orb 1"
    />
    <v-row class="ml-16 laptop">
      <v-col sm="5" md="5" lg="5" class="mt-n5">
        <div id="sub1" class="ml-16">
          <h1 class="sub-title">First Part</h1>
          <p id="paragraph" class="mt-n5">
            To us, the community comes first. The main goal is to make sure your
            investment and our mint are as successful as possible, to achieve
            all of our goals.
          </p>
        </div>
        <div id="sub2" class="ml-8">
          <h1 class="sub-title">Launch of our Merch & Exclusive Event</h1>
          <p id="paragraph" class="mt-n5">
            We will release our first merch collection of Bored Bunny that will
            be available only for the holder.
          </p>
        </div>
        <div id="sub3">
          <h1 class="sub-title">Funding Time & Breeding Unlock</h1>
          <p id="paragraph" class="mt-n5">
            We are committed to support, invest, reward, and collaborate with
            the best projects in the space and projects ideas of our members.
          </p>
        </div>
        <div id="sub4" class="ml-8">
          <h1 class="sub-title">Kitty Club City</h1>
          <p id="paragraph" class="mt-n5">
            We are planning to buy some land for our Community The Bored Bunny
            community will have access to private events in the Metaverse.
          </p>
        </div>
        <div id="sub5" class="ml-16">
          <h1 class="sub-title">Kitty Club Over The World</h1>
          <p id="paragraph" class="mt-n5">
            We want to show you that you made the best choice to join Bored
            Bunny and make sure that your investment is profitable.
          </p>
        </div>
      </v-col>
      <v-col xs="8" sm="7" md="7" lg="7" class="">
        <h1 id="title" class="float-right">
          The kitty <br />
          <span style="color: #d9ad59">Roadmap</span>
        </h1>
        <p id="info" class="float-right">Our plans moving forward into 2022</p>
      </v-col>
    </v-row>
    <v-row class="justify-center phone">
      <v-col cols="12">
      <h1 id="title" class="text-center" >The Kitty <span style="color:#D9AD59">Roadmap</span></h1>
      </v-col>
      <v-col cols="3"><img
      class="month"
      :src="require(`../assets/jan-month.png`)"
      alt="Orb 1"
    />
      </v-col>
      <v-col cols="8"><div id="sub1" class="ml-16">
          <h1 class="sub-title">First Part</h1>
          <p id="paragraph" class="mt-n4">
            To us, the community comes first. The main goal is to make sure your
            investment and our mint are as successful as possible, to achieve
            all of our goals.
          </p>
        </div></v-col>
      </v-col>
      <v-col cols="3"><img
      class="month"
      :src="require(`../assets/feb-month.png`)"
      alt="Orb 1"
    />
      </v-col>
      <v-col cols="8"><div id="sub2" class="ml-8">
          <h1 class="sub-title">Launch of our Merch & Exclusive Event</h1>
          <p id="paragraph" class="mt-n4">
            We will release our first merch collection of Bored Bunny that will
            be available only for the holder.
          </p>
        </div></v-col>
      </v-col>
      <v-col cols="3"><img
      class="month"
      :src="require(`../assets/mar-month.png`)"
      alt="Orb 1"
    />
      </v-col>
      <v-col cols="8"><div id="sub3" class="ml-8">
          <h1 class="sub-title">Funding Time
& Breeding Unlock</h1>
          <p id="paragraph" class="mt-n4">
            We are committed to support, invest, reward, and collaborate with the best projects in the space and projects ideas of our members.
          </p>
        </div></v-col>
      </v-col>
      <v-col cols="3"><img
      class="month"
      :src="require(`../assets/april-month.png`)"
      alt="Orb 1"
    />
      </v-col>
      <v-col cols="8"><div id="sub1" class="ml-16">
          <h1 class="sub-title">Kitty Club City</h1>
          <p id="paragraph" class="mt-n4">
            We are planning to buy some land for our Community The Bored Bunny community will have access to private events in the Metaverse.
          </p>
        </div></v-col>
      </v-col>
      <v-col cols="3"><img
      class="month"
      :src="require(`../assets/may-month.png`)"
      alt="Orb 1"
    />
      </v-col>
      <v-col cols="8"><div id="sub1" class="ml-16">
          <h1 class="sub-title">Kitty Club
Over The World</h1>
          <p id="paragraph" class="mt-n4">
            We want to show you that you made the best choice to join Bored Bunny and make sure that your investment is profitable.
          </p>
        </div></v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Roadmap",
};
</script>
<style scoped>
.phone {
  display: none;
}
.sub-title {
  color: #f6c973 !important;
  font-weight: 500 !important;
  font-size: 1.5vw !important;
  line-height: 1.5vw !important;
  right: 0;
  margin-top: 55px !important;
  margin-bottom: 20px !important;
}
#info {
  margin: 75vh -18vw 0 0 !important;
}
#title {
  color: white !important;
  font-weight: 500 !important;
  font-size: 4vw !important;
  line-height: 4vw !important;
  margin: 55vh 5vw 0 0 !important;
}
#paragraph {
  color: white !important;
  font-weight: 300 !important;
  font-size: 1.2vw !important;
  line-height: 1.2vw !important;
}
#roadmap-page {
  color: white;
  height: calc(100vh - 80px);
  background: #0f0f0f;
  position: relative;
  overflow: hidden;
}
#orb-1 {
  position: absolute;
  top: -20%;
  left: -15%;
  z-index: 0;
  opacity: 0.8;
}
#roadmap {
  height: 80vh;
  position: absolute;
  left: 45%;
}
#roadmap-cat {
  position: absolute;
  top: -30%;
  right: -8%;
  width: 55vw;

  z-index: 0;
  opacity: 0.8;
}
@media screen and (max-width: 961px) {
  #roadmap-cat {
    display: none;
  }
  #title {
    color: white !important;
    font-weight: 500 !important;
    font-size: 5vw !important;
    line-height: 5vw !important;
    margin: 40vh 2vw 0 0 !important;
  }
  #info {
    margin: 49vh -25vw 0 0 !important;
    font-size: 1.5vw !important;
  }
  #roadmap-page {
    height: initial;
    width: 100vw;
    margin-top: 0px !important;
  }
  .sub-title {
    font-size: 3vw !important;
    line-height: 3vw !important;
    margin-top: 70px !important;
    margin-bottom: 20px !important;
  }
  #roadmap {
    height: 70vh;
    left: 50vw;
    top: 7vh;
  }
  #sub1,
  #sub2,
  #sub4,
  #sub3,
  #sub5 {
    margin-left: -40px !important;
  }

  #paragraph {
    font-size: 2.5vw !important;
    line-height: 2.5vw !important;
  }
}
@media screen and (max-width: 769px) {
  .sub-title {
    margin-top: 55px !important;
  }
}
@media screen and (max-width: 600px) {
  .laptop {
    display: none;
  }
  .phone {
    display: flex;
  }
  #sub1,
  #sub2,
  #sub4,
  #sub3,
  #sub5 {
    margin-left: 0 !important;
  }
  .sub-title {
    margin-top: 10px !important;
    margin-bottom: 20px !important;
    font-size: 5vw !important;
    line-height: 5vw !important;
  }
  .month {
    width: 20vw;
    margin-left: -20px;
  }
  #paragraph {
    font-size: 3vw !important;
    line-height: 3vw !important;
  }
  #title {
    margin: 0 !important;
    font-size: 8vw !important;
    line-height: 8vw !important;
  }
  
}
@media screen and (max-width: 376px) {
  #sub1,
  #sub2,
  #sub4,
  #sub3,
  #sub5 {
    margin-left: -20px !important;
  }
  .sub-title {
    margin-top: 10px !important;
    margin-bottom: 20px !important;
    font-size: 4vw !important;
    line-height: 4vw !important;
  }
  .month {
    width: 20vw;
    margin-left: -20px;
  }
  #paragraph {
    font-size: 2.5vw !important;
    line-height: 2.5vw !important;
  }
  #title {
    margin: 0 !important;
    font-size: 8vw !important;
    line-height: 8vw !important;
  }
  
}
</style>
